module.exports = __webpack_public_path__ + "img/main_dlw.4f47dfb6.jpg";